export const carbonFiltersEnum = {
  DATE: 'date-filter',
  SUBSIDIARIES: 'subsidiaries',
  REGIONS: 'regions-filter',
  NF_TYPE: 'nf-type',
  CUSTOMERS: 'customers',
  MODAL: 'modal',
};

export const REGION = {
  NORTH: 1,
  MORTHEAST: 2,
  MIDWEST: 3,
  SOUTHEAST: 4,
  SOUTH: 5,
};

export const INVOICE = {
  MY_INVOICE: 0,
  CLIENT_INVOICE: 1,
};

export const invoiceEnumTransKey = {
  [INVOICE.MY_INVOICE]: 'Minhas notas',
  [INVOICE.CLIENT_INVOICE]: 'Notas de clientes',
};

export const MODAL = {
  HIGHWAY: 1,
  AIRLINE: 2,
}

export const modalEnumTransKey = {
  [MODAL.HIGHWAY]: 'Rodoviário',
  [MODAL.AIRLINE]: 'Aeroviário',
};
